export default __webpack_public_path__ + "static/media/home-scanpanda.bfb198bd.png";